import {InitPage} from "../index";
import swal from "sweetalert";

class InventoryValuation {
    constructor() {
      $(".btn_create_report").on('click', function() {
        if ($('#email').val() != '')
        {
          {
            swal({
              title: '',
              text:  'Are you sure to create the report?',
              icon: "warning",
              closeOnClickOutside: false,
              buttons: {
                cancel: {
                  text: "No",
                  value: null,
                  visible: true,
                  className: "sn-btn sn-btn-sm sn-btn-silver",
                  closeModal: true
                },
                confirm: {
                  text: "Yes",
                  value: true,
                  visible: true,
                  className: "sn-btn sn-btn-sm sn-btn-red",
                  closeModal: true
                }
              },
              dangerMode: true,
            }).then((willConfirm) => {
              if (willConfirm) {
                $('#inventory_valuation_report_form').submit();
              }
            });
          }
        }
        else {
            $('#error_message').text('This field is required.');
        }
      });

        $('#email').on('input', function(){
          if($(this).val() != '')
              $('#error_message').text('');
        });
    }
}


export function LoadPage() {
    InitPage("inventory_valuation", () => {
        const inventory_valuation = new InventoryValuation();
    });
}
